import { createContext } from 'react';

const LoginContext = createContext();
export default LoginContext;



// WEBPACK FOOTER //
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Login/loginContext.js